import { RouteFactory } from "@app/routePaths";
import { BlockTitle } from "@blocks/Blocks";
import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import GAData from "@components/GAData/GAData";
import Header from "@components/Header/Header";
import MetaTags from "@components/MetaTags/MetaTags";
import { useDetectAdBlock } from "adblock-detect-react";

const TermsAndConditionsPage = (): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();

  return (
    <div className="w-full" data-testid="terms-and-conditions-page-component">
      <AdSettings
        adNames={["lb1", "catfish", "abm", "prestitial"]}
        path={RouteFactory.termsAndConditions}
      />

      <MetaTags
        title="Paid Press Release Terms and Conditions"
        description="Read more at the Business Times."
        slug={RouteFactory.termsAndConditions}
      />

      <GAData
        title="Paid Press Release Terms and Conditions"
        level2="miscellaneous"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <Ad
        adType="lb1"
        className="flex min-h-[calc(50px+0.50rem)] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[calc(250px+1.5rem)]"
      />

      <Header />

      <div
        className="container !m-10 !mx-auto px-3 font-poppins"
        data-testid="paid-press-release-terms-and-conditions-component"
      >
        <BlockTitle
          text="Paid Press Release Terms and Conditions"
          rootClassName="mb-4 text-verticals-btblue text-5xl font-medium lg:text-6xl"
        />

        <p>
          By submitting the application and to enable us to publish your Press
          Release on The Business Times, you hereby agree unreservedly to our{" "}
          <a
            href="https://www.sph.com.sg/tnc/general_advertising"
            className="text-verticals-btblue underline hover:text-black"
            target="_blank"
            rel="noreferrer"
          >
            Advertising Terms & Conditions
          </a>
          ,{" "}
          <a
            href="https://www.sph.com.sg/tnc/website/"
            className="text-verticals-btblue underline hover:text-black"
            target="_blank"
            rel="noreferrer"
          >
            Website Terms and Conditions
          </a>{" "}
          and{" "}
          <a
            href="https://www.sph.com.sg/tnc/privacy/"
            className="text-verticals-btblue underline hover:text-black"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          . Without limitation to any of the foregoing:
        </p>

        <ul className="list-decimal space-y-2 pl-16">
          <li>
            You agree that the application, once submitted, is non-cancellable.
            In the event that you do not require us to publish the Press Release
            or would like us to cease publication of the Press Release, all fees
            are still payable and non-refundable
          </li>
          <li>
            You agree that SPH Media Limited (&quot;SPH&quot;) shall have all
            rights and permissions to freely publish, display and host the Press
            Release on The Business Times. You further confirm that you own all
            intellectual property rights in respect of all content in the Press
            Release submitted to us, or has obtained and will maintain all
            third-party consents, permissions, approvals, licences and permits
            required to publish the Press Release on The Business Times, and
            undertakes to be solely responsible for complying with the terms and
            conditions of the aforesaid consents, permissions, approvals,
            licences and permits
          </li>
          <li>
            You represent and warrant that the publication of the Press Release
            on The Business Times does not and will not violate or infringe upon
            any applicable law or regulation or other rights of any person
          </li>
          <li>
            In the event that any claim or allegation is made or if at any time
            it is the opinion of SPH that the Press Release infringes upon any
            applicable law or regulation or other rights of any person, SPH
            shall be entitled in its absolute discretion to, without prior
            consent and without further liability: (i) decline to publish or
            cease the publication of the Press Release (ii) require you to make
            such revision to the Press Release by a deadline specified by SPH
            (iii) publish an apology or retraction in such form as it considers
            appropriate and/or (iv) enter into any compromise or settlement
            agreement
          </li>
          <li>
            You acknowledge and agree that SPH disclaims all warranties, express
            or implied, including, but not limited to, implied warranties of
            satisfactory quality, merchantability or fitness for a particular
            purpose, compliance with description, or the warranty of
            non-infringement, and that our approval of your application does not
            constitute endorsement of the Press Release or that the Press
            Release is in compliance with all regulatory or legal requirements
          </li>
          <li>
            You agree that SPH has no control over, and is not responsible for,
            any site accessed or used by you (including for the purpose of
            making payment to SPH) or for any damage you may incur from your use
            of such site, and you hereby irrevocably waive any claim against SPH
            with respect to your use of such site
          </li>
          <li>
            You agree and consent to SPH and its related corporations as well as
            their respective employees, representatives and agents collecting,
            using, disclosing and/or otherwise processing all personal data
            provided to SPH, in accordance with our Privacy Policy including for
            the purposes of publishing the Press Release, processing payments,
            communicating with you regarding the Press Release and related
            purposes. You confirm that that if any third party personal data is
            provided to SPH, you have obtained all necessary consents from such
            individuals for the aforesaid purposes
          </li>
          <li>
            You shall fully indemnify and hold harmless SPH from and against any
            loss, claim, action, demand, cost or expenses (including legal costs
            on a full indemnity basis) which SPH may sustain, incur or suffer as
            a result of the Press Release breaching any applicable laws and/or
            any breach of your above representations and warranties.
          </li>
        </ul>
      </div>

      <Ad adType="catfish" />

      <Ad adType="abm" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default TermsAndConditionsPage;
